import styled from 'styled-components';

export const HeaderContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	align-items: flex-start;
`;

export const BadgeContainerStyled = styled.div`
	margin-top: 4px;
`;
